export const marketingKeys = {
	marketingInfo: (hpMarketingType: string) => ['MARKETING_INFO', hpMarketingType] as const
};
